import React from "react";
import {Collapse, Space} from "antd";

const {Panel} = Collapse;
export default (props) => {
    let textScript = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;
    return (
        <Space direction="vertical">
            <Collapse collapsible="header" key={"1"}>
                <Panel header="Call Script" key="1" style={{minWidth: "100%"}}>
                    {contentHtml()}
                </Panel>
            </Collapse>
        </Space>
    )
}

const contentHtml = () => {
    return (
        <React.Fragment>
            <div>
                <p>
                    <strong>Consultant:</strong>
                    <strong></strong>
                </p>
            </div>
            <div>
                <p>
                    · Welcome, thank you for calling EFF Gender Based Violence Help Desk.
                </p>
                <ul>
                    <li>
                        My name is ………….
                    </li>
                </ul>
                <p>
                    · How may I help you?
                </p>
                <ul>
                    <li>
                        Nka thusa jwang?
                    </li>
                </ul>
                <p>
                    · Ngikuncenda njani?
                </p>
            </div>
            <div>
                <p>
                    <strong>Caller:</strong>
                    <strong></strong>
                </p>
            </div>
            <div>
                <p>
                    …………………………. (narrating the story).
                </p>
            </div>
            <div>
                <p>
                    <strong>Consultant:</strong>
                </p>
            </div>
            <div>
                <p>
                    I hear, feel and understand your situation.
                </p>
                <p>
                    Ndiyakuva, ndiyavelana nawe, ndiyayiva intlungu yakho.
                </p>
                <p>
                    Kea utlwa, kea utlisisa, kibile, ke utlwelana le wena.
                </p>
            </div>
            <div>
                <p>
                    <strong>Consultant:</strong>
                </p>
            </div>
            <div>
                <p>
                    Please note that your matter will not be shared with anyone without
                    your consent/permission.
                </p>
            </div>
            <div>
                <p>
                    <strong>Consultant:</strong>
                </p>
                <p>
                    Are you safe where you are? Is there anyone that you trust that I can
                    call? Does anyone know about the incident?
                </p>
            </div>
            <div>
                <p>
                    <strong>Calling friend/parent</strong>
                </p>
            </div>
            <p>
                <strong></strong>
            </p>
            <div>
                <p>
                    Good day Mama, my name is………………… I am calling from the EFF help desk
                    for Gender Based Violence.
                </p>
                <p>
                    A problem has occurred with your …………, she/he has been victimised and
                    she/he has given us a permission to call you.
                </p>
                <p>
                    We have her here on the line, you can talk to her right now and ask her
                    what steps she prefers to start taking.
                </p>
                <p>
                    According to the address you have provided me with, where is your
                    nearest police station?
                </p>
                <p>
                    Have you called the police/ ambulance yet?
                </p>
                <p>
                    (In case of a ‘NO’ response) would you like me to call the police for
                    you?
                </p>
                <p>
                    Thank you for calling EFF Gender Based Violence, we will do our level
                    best to assist you.
                </p>
                <p>
                    We will do a follow up.
                </p>
            </div>
        </React.Fragment>
    )
}
